<template>
  <div>
    <TermsPopUp
      ref="terms"
      :class="termsFlag"
      @termsToggleChange="termsToggleChange"
    />
    <div class="app-wrap">
      <AppSignUpHeader v-if="isRegister"
        :termsToggle="termsToggle"
        @termsToggleChange="termsToggleChange"
        :headerText="headerText"
        @closeComponentEmit="closeComponentEmit"
        :headerBtn="true"
      />
      <div class="app-header app-header-content" style="top: 0;" v-else>
        <img src="@/assets/img/bi_order_app_v.png" class="app-header-bi">
        <div class="app-header-end" v-if="osCheck">
          <span @click="() =>{$emit('appClose')}">종료</span>
        </div>
      </div>
      <ProgressBar v-if="isRegister">
        <template #text>약관동의</template>
        <template #step1>
          <div class="progress-on"></div>
        </template>
      </ProgressBar>
      <div class="agree-wrap" style="margin-bottom: 80px">
        <div class="title">
          <p>
            <template v-if="!isRegister">반갑습니다!<br /></template>
            서비스 이용을 위한<br>
            <span class="fc-4c3bc5 fwb">약관동의가 필요합니다</span>
          </p>
        </div>
        <div class="agree-group">
          <div class="title">
            <label for="agree1" v-if="isRegister">
              <input type="checkbox" id="agree1" v-model="allCheck" @click="selectCheckAll">
              <span></span>
              <span>전체약관에 동의합니다</span>
            </label>
          </div>
          <ul class="agree-list">
            <li v-for="( term ) in agreeList" :key="term.name">
              <label :for="term.name">
                <input type="checkbox" :id="term.name" v-model="term.isApprove" @change="setAllCheck">
                <span></span>
                <span class="txt">
                  <span class="txt-imp">{{ essentialFlag(term) }} </span>
                  <span>{{ term.name }}</span>
                </span>
              </label>
              <span @click="termsDetailOpenHardCode(term)" :data-agree="term.name">보기</span>
            </li>
          </ul>
        </div>
      </div>
      <button class="full-login-btn" @click="nextStep" :disabled="!allCheck">
        다음
      </button>
    </div>
  </div>
</template>

<script lang="js">
import AppSignUpHeader from '@/components/Header/AppSignUpHeader.vue'
import ProgressBar from '@/components/SignUp/ProgressBar.vue'
import TermsPopUp from '@/components/Terms/TermsPopUp.vue'
import TermsMixins from '@/utils/TermsMixins'

export default {
  components: {
    AppSignUpHeader,
    ProgressBar,
    TermsPopUp
  },
  props: {
    isRegister: {
      type: Boolean,
      required: false,
      default: true
    },
    osCheck: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mixins: [TermsMixins],
  data () {
    return {
      headerText: '시작하기',
      termsToggle: false
    }
  },
  created () {
    this.setTermsByHardCode()
  },
  methods: {
    setTermsByHardCode () {
      const baseUrl = 'https://partner.modnpay.kr/policyView?seq='
      if (this.isRegister) {
        this.agreeList = [
          {
            name: '모든오더 서비스 이용약관',
            url: `${baseUrl}5`,
            optionFlag: 0,
            isApprove: false
          },
          {
            name: '전자지급결제대행 서비스 이용약관',
            url: `${baseUrl}6`,
            optionFlag: 0,
            isApprove: false
          },
          {
            name: '개인정보처리방침',
            url: `${baseUrl}14`,
            optionFlag: 0,
            isApprove: false
          },
          {
            name: '개인정보 수집 및 이용동의',
            url: `${baseUrl}12`,
            optionFlag: 0,
            isApprove: false
          },
          {
            name: '개인정보 제3자 제공 및 위탁 동의',
            url: `${baseUrl}13`,
            optionFlag: 0,
            isApprove: false
          },
          {
            name: '위치기반 서비스 이용약관',
            url: `${baseUrl}7`,
            optionFlag: 0,
            isApprove: false
          }
        ]
      } else {
        this.agreeList = [
          {
            name: '위치기반 서비스 이용약관',
            url: `${baseUrl}7`,
            // url: `${baseUrl}46`, // 테스트 약관 Seq
            optionFlag: 0,
            isApprove: false
          }
        ]
      }
    },
    nextStep () {
      if (this.isRegister) {
        this.$emit('nextComponent', { componentName: 'AppSignUpAuthPage' })
      } else {
        this.appMoveFirstAddress()
      }
    }
  },
  watch: {
    termsToggle () {
      if (this.termsToggle) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').removeAttribute('style')
      }
    }
  },
  computed: {
    essentialFlag () {
      return (term) => term.optionFlag === 0 ? '(필수)' : '(선택)'
    }
  }
}
</script>

<style>

</style>
